import {useQuery} from '@github-ui/react-query'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'
import type {Pull} from '@github-ui/agent-sessions/types/pull'
import type {Session} from '@github-ui/agent-sessions/types/session'
import type {PublicUser} from '@github-ui/agent-sessions/types/public-user'

export interface TaskPayloadData {
  currentUserCanPush: boolean
  steeringEnabled: boolean
  pull?: Pull
  sessions: Session[]
  currentUser?: PublicUser
  sessionOwners: PublicUser[]
}

/**
 * Fetches the task payload including permissions, pull request, sessions,
 * current user, and session owners from the task endpoint.
 */
export function useTaskPermissions(owner: string, repo: string, taskId: string) {
  return useQuery<TaskPayloadData>({
    queryKey: ['task-permissions', owner, repo, taskId],
    queryFn: async () => {
      const resp = await verifiedFetchJSON(`/copilot/t/${owner}/${repo}/${taskId}`)
      if (!resp.ok) {
        throw new Error(`Failed to fetch task permissions: ${resp.status} ${resp.statusText}`)
      }
      const data = await resp.json()
      return {
        currentUserCanPush: data.currentUserCanPush ?? false,
        steeringEnabled: data.steeringEnabled ?? false,
        pull: data.pull,
        sessions: data.sessions ?? [],
        currentUser: data.currentUser,
        sessionOwners: data.sessionOwners ?? [],
      }
    },
    enabled: !!owner && !!repo && !!taskId,
    staleTime: Infinity,
  })
}
